import React, { Component } from 'react'
import { css } from "emotion";
import {AirForce, 
        BOA, 
        Hilton, 
        Hyatt, 
        Marriott, 
        Trump, 
        OmniHotels, 
        USGov} from '../../assets/logos'

const basicNav = css`
  display: flex;
  align-items: center; /* Default */
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
  background: crimson;

  p {
    color: white;
    font-size: 1.15rem;
    font-style: oblique;
  }

  @media (min-width: 832px) {
    padding: 0.25rem 64px;
  }

  
`;
const hiddenNav = css`
  @media (max-width: 600px) {
    display: none;
  }
`;
const showNav = css`
  @media (max-width: 600px) {
    padding: 16px;
  }
`;

const LogoBar = () => (
  <div>
    <ul className={basicNav}>
      <p className={hiddenNav}>Trusted By</p>
      <li className={hiddenNav}>
        <img src={AirForce} alt="PCS client AirForce" />
      </li>
      <li className={hiddenNav}>
        <img src={BOA} alt="PCS client BOA" />
      </li>
      <li className={showNav}>
        <img src={Hilton} alt="PCS client Hilton" />
      </li>
      <li>
        <img src={Hyatt} alt="PCS client Hyatt" />
      </li>
      <li className={showNav}>
        <img src={Marriott} alt="PCS client Marriott" />
      </li>
      <li className={showNav}>
        <img src={Trump} alt="PCS client Trump" />
      </li>
      <li className={hiddenNav}>
        <img src={OmniHotels} alt="PCS client OmniHotels" />
      </li>
      <li className={hiddenNav}>
        <img src={USGov} alt="PCS client USGov" />
      </li>
    </ul>
  </div>
);

export default LogoBar;


// WEBPACK FOOTER //
// ./src/components/LogoBar/index.js